var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditOutlinedIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.79753 11.3222C1.82624 11.0638 1.8406 10.9346 1.8797 10.8138C1.91438 10.7066 1.9634 10.6047 2.0254 10.5106C2.09528 10.4047 2.18722 10.3127 2.37108 10.1289L10.625 1.87494C11.3154 1.18459 12.4347 1.18459 13.125 1.87494C13.8154 2.5653 13.8154 3.68459 13.125 4.37495L4.87108 12.6289C4.68722 12.8127 4.59528 12.9047 4.4893 12.9745C4.39528 13.0366 4.29331 13.0856 4.18615 13.1202C4.06538 13.1593 3.93616 13.1737 3.67773 13.2024L1.5625 13.4374L1.79753 11.3222Z",
    stroke: "black",
    strokeOpacity: 0.54,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOutlinedIcon);
export default __webpack_public_path__ + "static/media/edit-outlined-icon.9214a0e27c1cb8cb10825c2bf16ad325.svg";
export { ForwardRef as ReactComponent };